<template>
	<BackButton :text="t('back_button.overview')" link="Home" />
	<!-- <InfoButton v-if="te(`quiz.vragen[${currentQuestion}]`)" @click="showOverlay" /> -->
	<QuizOverlay v-if="overlayVisible" @click="hideOverlay" />
	<div v-show="te(`quiz.vragen[${currentQuestion}]`)" class="quiz justify-content-center">
		<div class="quiz-question">
			<div class="d-flex h-100">
				<h1 class="text-center text-white m-auto">{{ t(`quiz.vragen[${currentQuestion}].vraag`) }}</h1>
			</div>
		</div>
		<div class="row justify-content-center" style="margin-top: auto; margin-bottom: 190px;">

			<div class="col-6" style="max-height: 500px;">
				<img class="quiz-image" :src="t(`quiz.vragen[${currentQuestion}].afbeelding`)" />
			</div>
			<div class="col-6">
				<div class="d-flex h-100">
					<div class="my-auto">
						<AnswerButton :overlay="index == 0 && overlayVisible" :class="{ 'overlay-items' : overlayVisible }" :ref="el => { addAnswerButton(el, index) }" @click="answerQuestion(index, answer.correct, $event)" :correct="answer.correct" :answerNumber="index" :answer="answer.antwoord" v-for="(answer, index) in tm(`quiz.vragen[${currentQuestion}].antwoorden`)" :key="answer" />
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="explanation-wrapper">
		<div class="explanation-wrapper-container">
			<div v-show="hasAnswered" id="explanation" class="explanation-overlay">
				<div @click="explanationToggle" class="explanation-close-btn">
					<div class="d-flex h-100 w-100">
						<img class="m-auto" src="~@/assets/img/exit_white.svg" />
					</div>
				</div>
				<div @click="explanationToggle" class="explanation-slide-btn">
					<div class="d-flex h-100 w-100">
						<img id="explanation-slide-btn" class="m-auto" src="~@/assets/img/collapse-arrow.svg" />
					</div>
				</div>
				<div class="explanation-container">
					<h1 class="explanation-title">{{ t('quiz_text.explanation') }}</h1>
					<p class="explanation-info">{{ t(`quiz.vragen[${currentQuestion}].uitleg`) }}</p>
					<QuizButton class="next-question" @click="nextQuestion" bordertype="br" :text="t('quiz_text.next_question')" />
				</div>
			</div>
		</div>
	</div>
	<div v-show="te(`quiz.vragen[${currentQuestion}]`) == false" class="h-100 text-title-clr" style="display: flex;">
		<div class="m-auto">
			<h1 class="text-center" v-if="correctQuestions / totalQuestions == 1">{{ t('quiz.result.100') }}</h1>
			<h1 class="text-center" v-else-if="correctQuestions / totalQuestions >= 0.75">{{ t('quiz.result.75') }}</h1>
			<h1 class="text-center" v-else-if="correctQuestions / totalQuestions >= 0.5">{{ t('quiz.result.50') }}</h1>
			<h1 class="text-center" v-else>{{ t('quiz.result.below_50') }}</h1>
			<h1 class="text-center">{{ correctQuestions }} {{ t('quiz_text.out_of') }} {{ totalQuestions }} {{ t('quiz_text.correct') }}</h1>
			<QuizButton :text="t('quiz_text.again')" @click="resetQuiz" class="mx-auto" style="margin-top: 50px;" />
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import QuizButton from "@/components/quiz/QuizButton.vue";
import AnswerButton from "@/components/quiz/AnswerButton.vue";
import QuizOverlay from "@/components/quiz/Overlay.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";
import Confetti from "canvas-confetti";
import { Modal } from "bootstrap";

export default {
	name: "QuizStart",
	components: {
		QuizButton,
		AnswerButton,
		BackButton,
		InfoButton,
		QuizOverlay,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	data() {
		return {
			hasAnswered: false,
			answerGiven: false,
			quizDone: false,
			totalPoints: 0,
			totalQuestions: 0,
			correctQuestions: 0,
			currentQuestion: 0,
			answerButtons: [],
			totalAnswerButtons: 0,
			confettiEndTime: null,
			confettiAllowed: true,
			Explanation: null,
			ExplanationSlideBtn: null,
			ExplanationCollapsed: true,
		};
	},
	beforeRouteLeave(to, from, next) {
		next();

		this.confettiAllowed = false;
	},
	mounted() {
		const { t, te, tm } = useI18n();

		this.totalQuestions = tm("quiz.vragen").length;

		this.Explanation = document.getElementById("explanation");

		this.ExplanationSlideBtn = document.getElementById("explanation-slide-btn");
	},
	methods: {
		ConfettiCannons() {
			var colors = ["#bb0000", "#ffffff"];

			Confetti({
				particleCount: 2,
				angle: 60,
				spread: 55,
				origin: { x: 0 },
				colors: colors,
			});
			Confetti({
				particleCount: 2,
				angle: 120,
				spread: 55,
				origin: { x: 1 },
				colors: colors,
			});

			if (Date.now() < this.confettiEndTime && this.confettiAllowed) {
				requestAnimationFrame(this.ConfettiCannons);
			}
		},
		addAnswerButton(el, index) {
			if (el) {
				this.answerButtons[index] = el;
			}
		},
		answerQuestion(index, correct, event) {
			// Check if we have already given an answer, to prevent submitting it twice
			if (this.answerGiven) {
				return;
			}

			this.answerGiven = true;

			this.answerButtons[index].click();

			if (correct) {
				this.totalPoints++;
				this.correctQuestions++;
			}

			for (let i = 0; i < this.answerButtons.length; i++) {
				this.answerButtons[i].showCorrectAnswer();
			}

			this.Explanation.classList.remove("explanation-slide-out");
			this.Explanation.classList.add("explanation-slide-in");

			this.ExplanationSlideBtn.classList.remove("explanation-slide-btn-collapsed");
			this.ExplanationSlideBtn.classList.add("explanation-slide-btn-expanded");

			this.ExplanationCollapsed = false;

			this.hasAnswered = true;
		},
		resetQuiz(event) {
			this.currentQuestion = 0;
			this.totalPoints = 0;
			this.correctQuestions = 0;
			this.confettiAllowed = false;
		},
		nextQuestion(event) {
			this.Explanation.classList.remove("explanation-slide-in");
			this.Explanation.classList.add("explanation-slide-out");

			this.ExplanationSlideBtn.classList.remove("explanation-slide-btn-expanded");
			this.ExplanationSlideBtn.classList.add("explanation-slide-btn-collapsed");

			setTimeout(() => {
				this.answerButtons = [];
				this.currentQuestion++;
				this.hasAnswered = false;
				this.answerGiven = false;

				if (this.currentQuestion == this.totalQuestions) {
					if (this.correctQuestions == this.totalQuestions) {
						this.confettiEndTime = Date.now() + 5 * 1000;

						this.confettiAllowed = true;

						requestAnimationFrame(this.ConfettiCannons);
					}
				}
			}, 500);
		},
		explanationToggle(event) {
			// alert('whooop');
			if (this.ExplanationCollapsed) {
				this.Explanation.classList.remove("explanation-slide-out");
				this.Explanation.classList.add("explanation-slide-in");

				this.ExplanationSlideBtn.classList.remove("explanation-slide-btn-collapsed");
				this.ExplanationSlideBtn.classList.add("explanation-slide-btn-expanded");
			} else {
				this.Explanation.classList.remove("explanation-slide-in");
				this.Explanation.classList.add("explanation-slide-out");

				this.ExplanationSlideBtn.classList.remove("explanation-slide-btn-expanded");
				this.ExplanationSlideBtn.classList.add("explanation-slide-btn-collapsed");
			}

			this.ExplanationCollapsed = !this.ExplanationCollapsed;
		},
	},
};
</script>

<style scoped>
.quiz {
	position: relative;
	height: 100%;
	display: flex;
}

.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
	box-shadow: 0 0 10px 1px #fff;
}

.quiz-question {
	position: absolute;
	top: 120px;
	--height: 190px;
	background-color: rgba(255, 0, 0, 0);
	height: var(--height);
	max-height: var(--height);
}

.quiz-question h1 {
	--padding-side: 100px;
	font-size: 70px;
	padding-left: var(--padding-side);
	padding-right: var(--padding-side);
	line-height: 0.85;
}

.quiz-image {
	height: 500px;
	max-width: 100%;
}

.explanation-wrapper {
	pointer-events: none;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

.explanation-wrapper-container {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;;
}

.explanation-overlay {
	pointer-events: auto;
	position: absolute;
	z-index: var(--global-z-index-overlay-layer);
	right: 0;
	top: 0;
	bottom: 0;
	width: 822px;
	background-color: rgba(31, 31, 31, 0.95);
	padding: 0;
	color: #fff;
}

.explanation-title {
	font-size: 42px;
	font-weight: bold;
}

.explanation-info {
	font-size: 25px;
	font-weight: 400;
	max-height: 24em;
	text-overflow: ellipsis;
	word-wrap: break-word;
	overflow: hidden;
}

.next-question {
	position: absolute;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	bottom: 120px;
}

.explanation-close-btn {
	position: absolute;
	--size: 64px;
	height: var(--size);
	width: var(--size);
	left: 50px;
	top: 50px;
}

.explanation-slide-btn {
	position: absolute;
	--size: 64px;
	height: var(--size);
	width: var(--size);
	background-color: rgba(31, 31, 31, 0.95);
	left: calc(var(--size) * -1);
	top: 240px;
}

.explanation-slide-btn-expanded {
	animation: arrow-expanded 0.5s;
	transform: rotate(0deg);
}

.explanation-slide-btn-collapsed {
	animation: arrow-collapsed 0.5s;
	transform: rotate(180deg);
}

.explanation-slide-in {
	animation: slide-in 0.5s;
	right: 0;
}

.explanation-slide-out {
	animation: slide-out 0.5s;
	right: -822px;
}

.explanation-container {
	margin-left: 135px;
	margin-right: 135px;
	margin-top: 180px;
}

.explanation-container h1 {
	font-size: 48px;
	font-weight: bold;
}

@keyframes slide-in {
	from {
		right: -822px;
	}
	to {
		right: 0;
	}
}

@keyframes slide-out {
	from {
		right: 0;
	}
	to {
		right: -822px;
	}
}

@keyframes arrow-collapsed {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(180deg);
	}
}

@keyframes arrow-expanded {
	from {
		transform: rotate(180deg);
	}
	to {
		transform: rotate(0deg);
	}
}
</style>